const DrawingModeIcon = /*#__PURE__*/ [
  ["path", { d: "M16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 9H15C12.1716 9 10.7574 9 9.87868 9.87868C9 10.7574 9 12.1716 9 15V16C9 18.8284 9 20.2426 9.87868 21.1213C10.7574 22 12.1716 22 15 22H16C18.8284 22 20.2426 22 21.1213 21.1213C22 20.2426 22 18.8284 22 16V15C22 12.1716 22 10.7574 21.1213 9.87868C20.2426 9 18.8284 9 16 9Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export { DrawingModeIcon as default };
//# sourceMappingURL=DrawingModeIcon.js.map
